import {
  Show,
  ShowProps,
  SimpleShowLayout,
  TextField,
  NumberField,
  ImageField,
} from "react-admin";
import React from "react";

const BannerShow = (props: ShowProps) => (
  <Show {...props}>
    <SimpleShowLayout>
        <ImageField source="featured_image" />
        <TextField source="name_en" />
        <TextField source="name_ar" />
        <NumberField source="order_no" />
    </SimpleShowLayout>
  </Show>
);

export default BannerShow;
